import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { APIResponse } from 'shared/models/api-response';
import { Observable, map, take } from 'rxjs';
import { ApiService } from 'shared/services/api.service';
import { ToastService } from 'shared/services/toast.service';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule],
  selector: 'remote-login',
  templateUrl: './remote-login.component.html',
  styleUrls: ['./remote-login.component.scss']
})
export class RemoteLoginComponent {
  @Input('user') user
  loginUrl: string | null = null
  constructor(
    private _apiService: ApiService,
    private _toastService:ToastService
    ) {

  }

  public remoteLogin() {
    this._getRemoteAccessUrl().subscribe((url: string | null) => {
      if (url) {
        this.loginUrl = url;
      } 
    });
  }
  
  private _getRemoteAccessUrl(): Observable<string | null> {
    const url = 'http://localhost:4200/remote-login/';
    return this._apiService.createOneTimeToken(this.user._id)
      .pipe(
        take(1),
        map((response: APIResponse) => {
          if (response.success) {
            return `${url}${response.data.oneTimeTokenId}`;
          } else {
            this._toastService.warning('Nie udało się pobrać tokenu.');
            return null;
          }
        })
      );
  }
}
